import { render, staticRenderFns } from "./DomainExpiryManagement.vue?vue&type=template&id=208310cf&"
import script from "./DomainExpiryManagement.vue?vue&type=script&lang=js&"
export * from "./DomainExpiryManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports